import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Unit } from './interfaces/units';
import { unitFormatter } from '@icc/shared/helpers/b2b';

@Pipe({
    name: 'unit'
})
export class UnitPipe implements PipeTransform {

    constructor(private translateService: TranslateService) {}
    transform(unit: Unit, qty:number, short = false): string {
        return unitFormatter(
            unit,
            qty,
            this.translateService.instant.bind(this.translateService),
            short
        );
    }
}
